<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,3.58,12.42,0,8,0ZM9,3L9,5L7,5L7,3L9,3ZM6,12L6,13L10,13L10,12L9,12L9,6L6,6L6,7L7,7L7,12L6,12Z"
          fill-rule="evenodd"
          fill="#276CFF"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Info',
} as DefineComponent
</script>
